import(/* webpackMode: "eager" */ "/codebuild/output/src1090216177/src/apps/junonkuji/src/components/layouts/PageHeader/PageHeader.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1090216177/src/apps/junonkuji/src/components/ui/Pagination/Pagination.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1090216177/src/apps/junonkuji/src/features/article/components/ArticleSmallList/ArticleSmallList.module.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1090216177/src/apps/junonkuji/src/components/ui/ImageView/ImageView.module.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1090216177/src/node_modules/next/dist/client/link.js");
